module.exports = __webpack_public_path__ + "img/editIcon.3ae8531d.svg";